import type { JSONSchema7 } from 'json-schema';

export type ApplicationNameFieldUiOptions = {
  entityField: string;
  annotation: string;
};

export const ApplicationNameFieldSchema = {
  uiOptions: {
    type: 'object',
    required: ['entityField', 'annotation'],
    properties: {
      entityField: {
        type: 'string',
        title: 'Entity field',
        description: 'Form field containing the selected application entity',
      },
      annotation: {
        type: 'string',
        title: 'Annotation',
        description: 'Entity annotation used to prefill the application name',
      },
    },
  } as JSONSchema7,
  returnValue: {
    title: 'Application Name',
    type: 'string',
  } as JSONSchema7,
};
